import NodeFanCooledUnit from './node-fan-cooled-unit';

export default NodeFanCooledUnit;
